import * as allPageFr from './fr/import';

const generalTraductionFr = [];

function allTraductionFR(allTraduction) {
  Object.keys(allTraduction).forEach((key) => {
    generalTraductionFr[key] = allTraduction[key];
  });
}
// Pour les futurs modules il faut créer le fichier de translate import, l'import et
// appeller la fonction en dessous avec en parametre la liste de toutes les translate
allTraductionFR(allPageFr.PAGES);

// eslint-disable-next-line import/prefer-default-export
export const TRANSLATE = {
  fr: generalTraductionFr,
};



// WEBPACK FOOTER //
// ./src/i18n/translate.js